import Request from './request';
import snackbar from '@/plugins/snackbar';
import i18n from '@/i18n';
import store from '../store';

async function fetch(data) {
  return Request('get', "api/order-material-analyze/order-backlog", data);
}

async function Exports(data){
  store.dispatch("fullscreenLoading")
  const response = await Request('get',"api/order-material-analyze/order-backlog-export",data)
  if(response.data && response.data.status.isOK()){
      snackbar.info(i18n.t("Export.recordedHint"))
  }
  store.dispatch("fullscreenLoadingStop")
  return response
}

export default {
  fetch,
  Exports,
}
